module.exports = __webpack_public_path__ + "img/daebang.522ac414.png";